import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PolicyTemplates from './Templates/PolicyTemplates';
import Policies from './Policies';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { useGetUserData } from '../../api';
import { isUserPermitted } from '../utils';
import { Alert } from '@silverfort/sf-components';

const PoliciesRoutes: FC = () => {
    const match = useRouteMatch();
    const { loading, userSession } = useGetUserData();
    const isEditor = userSession && isUserPermitted(userSession.user, 'policies', ROLES.EDITOR.value);

    if (loading) {
        return (
            <div className="silverfort-loader">
                <div className="logo"></div>
            </div>
        );
    }

    if (!userSession) {
        return null;
    }

    return (
        <>
            {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
            <Switch>
                {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
                {isEditor && <Route path={`${match.path}/Templates/:categoryId?`} component={PolicyTemplates} />}
                {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
                <Route path={match.path}>
                    <Policies isEditor={isEditor} />
                </Route>
            </Switch>
            <Alert />
        </>
    );
};

export default PoliciesRoutes;
